<script setup lang="ts">

const platforms = [
  {
    name: 'WordPress',
    logo: '/images/cms/wordpress.svg',
    reason: 'Plugin bloat, constant updates, and security vulnerabilities slowing you down.',
    pain: ['40% of the web, and 90% of hacked CMS sites', 'Plugin conflicts after every update', 'Performance degrades as content grows', 'No native API or headless support'],
  },
  {
    name: 'MODX',
    logo: '/images/cms/modx.svg',
    reason: 'Ageing ecosystem with shrinking community support and limited modern tooling.',
    pain: ['Shrinking developer pool and community', 'No modern frontend framework support', 'Limited hosting and deployment options', 'Falling behind on PHP version support'],
  },
  {
    name: 'Drupal',
    logo: '/images/cms/drupal.svg',
    reason: 'Complex upgrades, steep learning curve, and heavy infrastructure requirements.',
    pain: ['Major version upgrades are full rebuilds', 'Requires specialist Drupal developers', 'Heavy server resource requirements', 'Overly complex for most business needs'],
  },
  {
    name: 'Joomla',
    logo: '/images/cms/joomla.svg',
    reason: 'Declining extensions, a fragmented admin and sites that get harder to scale.',
    pain: ['Extension marketplace is drying up', 'Confusing admin interface for content teams', 'Poor performance under high traffic', 'Security patches are slow to release'],
  },
  {
    name: 'Umbraco',
    logo: '/images/cms/umbraco.svg',
    reason: '.NET hosting costs and limited flexibility compared to modern Laravel.',
    pain: ['Windows/.NET hosting is expensive', 'Locked into Microsoft ecosystem', 'Fewer developers available vs PHP/Laravel', 'Limited open-source package ecosystem'],
  },
]

const benefits = [
  'Zero-downtime migration',
  'Content, data & users moved',
  'Full staff training included',
  'Comprehensive documentation',
]
</script>

<template>
  <section id="migration" class="relative overflow-hidden py-20 md:py-40">
    <div class="mx-auto max-w-7xl px-6 md:px-12 grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
      <div data-aos="fade">
        <div class="flex items-center gap-3 mb-6">
          <span class="text-xs tracking-[0.25em] text-blu-900 dark:text-blu-400 uppercase font-medium">CMS Migration</span>
        </div>

        <h2 class="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-700 dark:text-white mb-6">
          Outgrown your CMS?
        </h2>

        <p class="text-lg md:text-xl text-slate-700/80 dark:text-white/65 leading-relaxed text-pretty max-w-xl">
          Security patches, plugin conflicts and slow pages hold a business back. We move your content, data and users to Laravel with no downtime, then train your team.
        </p>
        <p class="mt-10">
          <NuxtLink to="/cms-migration" class="font-medium text-blu-600 underline decoration-dotted underline-offset-4 transition-colors hover:decoration-solid dark:text-blu-400">How a migration works</NuxtLink>
        </p>
      </div>
      <div>
        <MigrationConvergence :platforms="[...platforms, { name: 'Other', reason: 'Custom CMS, legacy systems, Sitecore, Kentico, Wix or Webflow. If it holds your content, we can move it.' }]" />
      </div>
    </div>
  </section>
</template>
